import { createFileRoute } from '@tanstack/react-router';

import { ShortlistPage } from '@/features/profiles/company-pages';

/** The person's own shortlist as an individual owner (`/me/shortlist`). */
export const Route = createFileRoute('/_app/account/shortlist')({
  component: PersonalShortlist,
});

function PersonalShortlist() {
  return <ShortlistPage orgId={null} />;
}
